import { UserCirclePlusIcon } from '@phosphor-icons/react'
import type { NodeProps } from '@xyflow/react'
import type { AssignOwnerFlowNode } from 'app/types/workflows'
import { NodeShell } from './NodeShell'

/** Sets the enrolled contact's owner. */
export function AssignOwnerNode({ data, selected }: NodeProps<AssignOwnerFlowNode>) {
  const name = data.ownerId ? data.ownerName || `a staff member` : undefined
  return (
    <NodeShell
      icon={UserCirclePlusIcon}
      accent="emerald"
      kind="Assign owner"
      label={data.label}
      description={name ? `Assign contact to ${name}` : `No owner chosen`}
      selected={selected}
    />
  )
}
